import {openwebActions, titleActions} from "../actionTypes";
import {_trim} from '../../utils/utils';
import Moment from 'moment';
import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `openwebActions.js`);

/** ---------------- action creators ---------------- */

const getOpenWebsRequest = (_updated) => ({
  type: openwebActions.GET_OPENWEBS_REQUEST,
  _updated,
});

const getOpenWebRequest = (id, _updated) => ({
  type: openwebActions.GET_OPENWEB_REQUEST,
  id,
  _updated,
});

const postOpenWebsRequest = (config) => ({
  type: openwebActions.POST_OPENWEBS_REQUEST,
  ...config,
});


/** ---------------- action sequences ---------------- */

const getOpenWebs = (_updated=null) => {
  return (dispatch) => {
    if (_updated !== null){
      const t = Moment(_updated).format('YYYY-MM-DDTHH:mm:ss');
      return dispatch(getOpenWebsRequest(t));
    } else {
      return dispatch(getOpenWebsRequest());
    }
  }
};

const getOpenWeb = (id, _updated) => {
  return (dispatch) => {
    return dispatch(getOpenWebRequest(id, _updated));
  }
};

const postOpenWebs = (config) => {
  debug.log(config);
  return (dispatch, getState) => {
    return dispatch(postOpenWebsRequest({...config, who: getState().auth.name}))
  }
};

export {
  getOpenWebs,
  getOpenWeb,
  postOpenWebs,
}


// WEBPACK FOOTER //
// ./src/data/openweb/openwebActions.js